import { Box, Button, Link, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { Trans, useTranslation } from 'react-i18next';
import { Dialog, DialogContentTitle, DialogTitle } from '~/components/dialogs/components';
import { DialogActions, DialogContent } from '~/components/dialogs/lib/styles';

export interface ReportDownloadDialogProps {
  close: () => void;
  from: DateTime | null;
  to: DateTime | null;
  reportUrl: string | null;
  title?: string;
  name?: string;
  closeLabel?: string;
}

export const ReportDownloadDialog = ({
  close,
  from,
  to,
  reportUrl,
  title,
  name,
  closeLabel,
}: ReportDownloadDialogProps) => {
  const { t, i18n } = useTranslation();

  const dates = {
    from: from?.setLocale(i18n.language).toLocaleString(DateTime.DATE_FULL),
    to: to?.setLocale(i18n.language).toLocaleString(DateTime.DATE_FULL),
  };

  return (
    <Dialog fullWidth maxWidth="md" onClose={close} open={Boolean(reportUrl)}>
      <DialogTitle onClose={close}>{title ?? t('pages.playout_reports.dialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentTitle>
          {name ? (
            <Trans
              i18nKey="pages.playout_reports.dialog.success_message_with_name"
              values={{ name, ...dates }}
              components={{ b: <b /> }}
            />
          ) : (
            <Trans
              i18nKey="pages.playout_reports.dialog.success_message"
              values={dates}
              components={{ b: <b /> }}
            />
          )}
        </DialogContentTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1">
            {t('pages.playout_reports.dialog.instructions')}
          </Typography>
          {reportUrl && (
            <Link sx={{ fontSize: '1.2em' }} target="_blank" rel="noreferrer" href={reportUrl}>
              {t('pages.playout_reports.dialog.link_text')}
            </Link>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="outlined">
          {closeLabel ?? t('common.dialogs.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
